"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTablePreloaderBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var BcDataTablePreloaderBehavior = (function () {
    function BcDataTablePreloaderBehavior(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.preloaderTableId = this.getPreloaderTableId();
    }
    BcDataTablePreloaderBehavior.prototype.getPreloaderTableId = function () {
        return this.bcDataTableConfig.id + bc_data_table_constants_1.BcDataTableConstansts.ATTR_TABINDEX_NEGATIVE + bc_data_table_constants_1.BcDataTableConstansts.PRELOADER;
    };
    BcDataTablePreloaderBehavior.prototype.init = function (dataTable) {
        var parentElement = dataTable.parentElement;
        var preloaderTable = this.createPreloaderTable(dataTable);
        if (this.bcDataTableConfig.preloader.columnHeader) {
            this.addPreloaderThead(preloaderTable);
        }
        this.addPreloaderTableRows(preloaderTable);
        parentElement.append(preloaderTable);
        if (this.bcDataTableConfig.preloader.header) {
            this.addPreloaderHeader(preloaderTable);
        }
        if (this.bcDataTableConfig.preloader.footer) {
            this.createPreloaderFooter(preloaderTable);
        }
        return this.preloaderTableId;
    };
    BcDataTablePreloaderBehavior.prototype.addPreloaderThead = function (dataTable) {
        var theadElement = document.createElement(common_constants_1.BcCommonConstants.THEAD_TAG);
        var trElement = document.createElement(common_constants_1.BcCommonConstants.TR_TAG);
        var numberColumnsTh = this.bcDataTableConfig.preloader.columns;
        for (var index = 0; index < numberColumnsTh; index++) {
            var thElement = document.createElement(common_constants_1.BcCommonConstants.TH_TAG);
            thElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_CLASS);
            trElement.appendChild(this.createPreloaderElement(thElement));
        }
        theadElement.appendChild(trElement);
        dataTable.prepend(theadElement);
    };
    BcDataTablePreloaderBehavior.prototype.addPreloaderHeader = function (dataTable) {
        var divContainerHeader = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divContainerHeader.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_CONTAINER);
        var divContent = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divContent.classList.add(bc_data_table_constants_1.BcDataTableConstansts.FLEX_CLASS, bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_BETWEEN_CLASS, bc_data_table_constants_1.BcDataTableConstansts.ROW_BORDER_CLASS);
        if (this.bcDataTableConfig.preloader.header.title) {
            this.createTitleHeader(divContent);
        }
        if (this.bcDataTableConfig.preloader.header.paginator) {
            this.createPaginatorHeader(divContent);
        }
        if (this.bcDataTableConfig.preloader.header.settings) {
            this.createSettingsHeader(divContent);
        }
        divContainerHeader.appendChild(divContent);
        dataTable.parentElement.prepend(divContainerHeader);
    };
    BcDataTablePreloaderBehavior.prototype.createSettingsHeader = function (divContent) {
        var divSettings = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divSettings.classList.add(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SETTINGS_CLASS);
        divSettings.style.display = common_constants_1.BcCommonConstants.FLEX;
        divSettings.style.alignItems = common_constants_1.BcCommonConstants.CENTER;
        divSettings.style.height = '80px';
        this.createPreloaderElement(divSettings);
        divContent.appendChild(divSettings);
    };
    BcDataTablePreloaderBehavior.prototype.createPaginatorHeader = function (divContent) {
        var divPaginator = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divPaginator.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_PAGINATOR_CLASS);
        divPaginator.style.display = common_constants_1.BcCommonConstants.FLEX;
        divPaginator.style.alignItems = common_constants_1.BcCommonConstants.CENTER;
        divPaginator.style.width = '400px';
        divPaginator.style.height = '80px';
        this.createPreloaderElement(divPaginator, true);
        divContent.appendChild(divPaginator);
    };
    BcDataTablePreloaderBehavior.prototype.createTitleHeader = function (divContent) {
        var divTitle = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divTitle.style.width = '300px';
        divTitle.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_TITLE_CLASS);
        this.createPreloaderElement(divTitle, true);
        divContent.appendChild(divTitle);
    };
    BcDataTablePreloaderBehavior.prototype.createPreloaderFooter = function (dataTable) {
        var divContainerFooter = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divContainerFooter.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_FOOTER_CONTAINER);
        var divContent = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var alignClass = this.validateAlignClass();
        divContent.classList.add(bc_data_table_constants_1.BcDataTableConstansts.FLEX_CLASS, bc_data_table_constants_1.BcDataTableConstansts.ROW_BORDER_CLASS);
        divContainerFooter.classList.add(bc_data_table_constants_1.BcDataTableConstansts.FLEX_CLASS, bc_data_table_constants_1.BcDataTableConstansts.ROW_BORDER_CLASS, alignClass);
        divContent.style.height = '80px';
        divContent.style.width = '400px';
        divContent.style.alignItems = common_constants_1.BcCommonConstants.CENTER;
        this.createPreloaderElement(divContent, true);
        divContainerFooter.appendChild(divContent);
        dataTable.parentElement.append(divContainerFooter);
    };
    BcDataTablePreloaderBehavior.prototype.validateAlignClass = function () {
        var alignClass = '';
        switch (this.bcDataTableConfig.preloader.footer.align) {
            case common_constants_1.BcCommonConstants.CENTER:
                alignClass = bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_XS_CENTER;
                break;
            case common_constants_1.BcCommonConstants.LEFT:
                alignClass = bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_BETWEEN_CLASS;
                break;
            default:
                alignClass = bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_FLEX_END;
                break;
        }
        return alignClass;
    };
    BcDataTablePreloaderBehavior.prototype.addPreloaderTableRows = function (dataTable) {
        var preloaderTableRows = this.bcDataTableConfig.preloader.rows;
        for (var index = 0; index < preloaderTableRows; index++) {
            var trElement = document.createElement(common_constants_1.BcCommonConstants.TR_TAG);
            var preloaderTableRow = this.addPreloaderTableColumns(trElement);
            dataTable.tBodies[0].appendChild(preloaderTableRow);
        }
    };
    BcDataTablePreloaderBehavior.prototype.addPreloaderTableColumns = function (preloaderTableRow) {
        var preloaderTableColumns = this.bcDataTableConfig.preloader.columns;
        for (var index = 0; index < preloaderTableColumns; index++) {
            var tdElement = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
            var preloaderTableColumn = this.createPreloaderElement(tdElement);
            preloaderTableRow.appendChild(preloaderTableColumn);
        }
        return preloaderTableRow;
    };
    BcDataTablePreloaderBehavior.prototype.createPreloaderElement = function (tdElement, isFull) {
        if (isFull === void 0) { isFull = false; }
        var divPreloader = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divPreloader.classList.add(bc_data_table_constants_1.BcDataTableConstansts.PRELOADER_CLASS);
        divPreloader.classList.add(bc_data_table_constants_1.BcDataTableConstansts.PRELOADER_CLASS_LINE);
        if (isFull) {
            divPreloader.setAttribute('width', 'full');
        }
        tdElement.append(divPreloader);
        return tdElement;
    };
    BcDataTablePreloaderBehavior.prototype.createPreloaderTable = function (dataTable) {
        var preloaderTable = document.createElement(common_constants_1.BcCommonConstants.TABLE_TAG);
        preloaderTable.createTBody();
        preloaderTable.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_CLASS);
        preloaderTable.setAttribute(common_constants_1.BcCommonConstants.ID, this.preloaderTableId);
        return preloaderTable;
    };
    return BcDataTablePreloaderBehavior;
}());
exports.BcDataTablePreloaderBehavior = BcDataTablePreloaderBehavior;
